import { type RefObject, useEffect } from 'react'

import type { BaseVerificationViewModel } from '@lib/store/playbook/BaseVerificationViewModel'

/**
 * Hook for managing input focus in verification components.
 * Automatically focuses the appropriate input based on the current verification step.
 *
 * @param viewModel - The verification view model instance
 * @param inputRef - Ref to the main input field (email/phone)
 * @param codeInputRef - Ref to the verification code input field
 */
export function useVerificationFocus(
    viewModel: BaseVerificationViewModel,
    inputRef: RefObject<HTMLInputElement | null>,
    codeInputRef: RefObject<HTMLInputElement | null>,
) {
    useEffect(() => {
        // Focus appropriate input based on step
        if (viewModel.currentStep === 'input' && inputRef.current) {
            inputRef.current.focus()
        } else if (
            viewModel.currentStep === 'code-input' &&
            codeInputRef.current
        ) {
            codeInputRef.current.focus()
        }
    }, [viewModel.currentStep, inputRef, codeInputRef])
}
